import {useQuery} from "@tanstack/react-query";
import {getPublicLotteryGamesService} from "../services/getPublicLotteryGames.service";

/**
 * Hook to fetch and cache public lottery games data
 * This hook can be used without authentication
 * Returns a simplified list of games with id, name, and logo
 */
const useGetPublicLotteryGames = () => {
  const {data, isPending, error} = useQuery({
    queryKey: ["public-lottery-games"],
    queryFn: getPublicLotteryGamesService,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    select: responseData => {
      const gamesList = responseData?.data?.data || [];
      if (!Array.isArray(gamesList)) return [];

      return gamesList.map((game, index) => ({
        id: game.id,
        name: game.name,
        logo: `https://images.cdn.raspaygana.com.ve/${game.logo}`,
        uniqueId: `lottery-${game.id}-${index}`,
      }));
    },
  });

  return {
    games: data || [],
    isPending,
    error,
  };
};

export default useGetPublicLotteryGames;
